module.exports = __webpack_public_path__ + "static/img/drive.2d27966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/drive.png
// module id = Vez2
// module chunks = 0